'use client';
import React from 'react';
import { LoadingView } from '@web/components';
import { useSessionCustomer } from '../customer';
import { Redirect } from './Redirect';
import { RedirectToLogin } from './RedirectToLogin';

/* this should be used for instances of standalone pages made
specifically for deeplinking to the APP. An example of this is:
- /account/box to redirect to the Box Screen */
export const RedirectToAccount = () => {
  const { isActive, isLoading: isCustomerLoading } = useSessionCustomer();

  if (!isCustomerLoading && !isActive) {
    return <RedirectToLogin />;
  }

  if (isCustomerLoading) {
    return <LoadingView />;
  }

  return <Redirect to={'/account'} />;
};

RedirectToAccount.displayName = 'RedirectToAccount';
